/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `revenue` - Revenue
* `employees` - Employees
* `floor_area` - Floor area
* `production_output` - Production output
* `other` - Other
 */
export type IntensityMetricTypeEnum = typeof IntensityMetricTypeEnum[keyof typeof IntensityMetricTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntensityMetricTypeEnum = {
  revenue: 'revenue',
  employees: 'employees',
  floor_area: 'floor_area',
  production_output: 'production_output',
  other: 'other',
} as const;
